import { TRA_CANCELLATION_COV, TRA_SKIING_COV } from '../../../constants/coverage';
import type { HighlightNoteContent } from '../types';

const getRemoveCoverageHighlightNote = (
    coverageId: string,
    coverageName: string,
    renewalDate: string,
    isFromDAFlow: boolean,
    getHippoText: (
        resourceKey: string,
        replaceTexts?: Record<string, string | number>
    ) => string = () => ''
): HighlightNoteContent | undefined => {
    switch (coverageId) {
        case 'PETLifeCov':
        case 'PETHealthCov':
        case 'PETHealthPlusCov':
            return {
                noteText: getHippoText(
                    'DSS-REMOVE-SIMPLE-COVERAGE-CANCELLATION-COVERAGE-INFORMATION-PET-HEALTH-LIFE'
                ),
                theme: 'warning'
            };
        case TRA_CANCELLATION_COV:
        case TRA_SKIING_COV:
            if (isFromDAFlow) {
                return undefined;
            } else {
                return {
                    noteTitle: getHippoText(
                        'DSS-REMOVE-SIMPLE-COVERAGE-CANCELLATION-COVERAGE-INFORMATION-TRAVEL-TITLE'
                    ),
                    noteText: getHippoText(
                        'DSS-REMOVE-SIMPLE-COVERAGE-CANCELLATION-COVERAGE-INFORMATION-TRAVEL-TEXT',
                        { coverageName, renewalDate }
                    ),
                    theme: 'info'
                };
            }
        default:
            return undefined;
    }
};

export { getRemoveCoverageHighlightNote };
